'use client';

import {
  FccLogo,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

interface FccComplianceStatementTemplateProps {
  readonly productKey: MessageKey;
}

const FccComplianceStatementTemplate = ({
  productKey,
}: FccComplianceStatementTemplateProps): JSX.Element => {
  const t = useTranslations();

  return (
    <LayoutGrid data-cy="fcc-compliance-statement-template">
      <GridItem
        colStart={{ sm: 'main', md: 3, xl: 6 }}
        colEnd={{ sm: 'main', md: 23, xl: 20 }}
      >
        <TypographyV3 variant="h1" className="mb-4 text-center">
          ŌURA
        </TypographyV3>
        <TypographyV3 className="mb-6 text-center text-3xl font-bold">
          {t('fcc_sdoc_title')}
        </TypographyV3>
        <TypographyV3 className="mb-6 text-xl">
          {t('fcc_sdoc_copy')}
        </TypographyV3>
        <TypographyV3 className="mb-6 text-center text-xl font-extrabold">
          {t('fcc_sdoc_oura')}
        </TypographyV3>
        <TypographyV3 className="mb-8 text-center text-xl font-extrabold">
          Elektroniikkatie 10, 90590 Oulu, Finland
        </TypographyV3>
        <TypographyV3 className="mb-8 text-xl font-medium">
          {t.rich(productKey)}
        </TypographyV3>
        <TypographyV3 className="mb-4 text-center text-xl font-medium underline">
          {t('fcc_sdoc_party')}
        </TypographyV3>
        <TypographyV3 className="mb-4 text-center text-xl font-bold">
          OURARING INC
        </TypographyV3>
        <TypographyV3 className="mb-4 text-center text-xl font-bold">
          222 Kearny St. 7th floor San Francisco 94108, California, USA
        </TypographyV3>
        <TypographyV3 className="mb-8 text-center text-xl font-bold">
          FRN 0035310408
        </TypographyV3>
        <TypographyV3 className="mb-4 text-xl font-medium">
          {t('fcc_sdoc_footer_one')}
        </TypographyV3>
        <TypographyV3 className="mb-4 text-xl font-medium">
          {t('fcc_sdoc_footer_two')}
        </TypographyV3>
        <TypographyV3 className="mb-16 text-xl font-medium">
          {t('fcc_sdoc_footer_three')}
        </TypographyV3>
        <div className="mb-10 flex flex-row justify-center">
          <FccLogo width={80} />
        </div>
      </GridItem>
    </LayoutGrid>
  );
};

export default FccComplianceStatementTemplate;
